import { css, cx } from 'linaria'

import * as colors from '../../styles/colors'
import { breakpoints, rel } from '../../styles/dimensions'
import * as styleUtils from '../../styles/utils'


export const header = cx(css`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 997;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${rel(8)}rem;
  padding-bottom: ${rel(8)}rem;
  color: ${colors.white};
  background-color: ${colors.primaryColor[2]};
  box-shadow: 0 ${rel(3)}rem ${rel(8)}rem -${rel(3)}rem ${colors.primaryColor[1]};

  @media print {
    display: none;
  }
`, styleUtils.container)

export const testServerBadge = css`
  position: absolute;
  top: 50%;
  left: ${rel(72)}rem;
  padding: ${rel(3)}rem ${rel(8)}rem;
  color: ${colors.primaryColor[1]};
  font-weight: 700;
  font-size: ${rel(13)}rem;
  line-height: 1.2;
  background-color: ${colors.actionColor[3]};
  border-radius: ${rel(4)}rem;
  transform: translateY(-50%);
  pointer-events: none;

  @media screen and (min-width: ${breakpoints.xl}) {
    left: ${rel(88)}rem;
  }
`
